import type { SearchCardTypes } from "@bonusx-global/bx-design-system";
import { SearchCard } from "@bonusx-global/bx-design-system";
import Grid from "@mui/material/Grid";
import useIsMobile from "../../../../hooks/device/useIsMobile";

export interface ResultItemProps {
  label: string;
  url: string;
  type: SearchCardTypes;
  onClick?: () => void;
}

export function ResultItem({ type, label, onClick }: Readonly<ResultItemProps>) {
  const isMobile = useIsMobile();
  return (
    <Grid item xs={12} onClick={onClick}>
      <SearchCard type={type} value={label} onClick={onClick} isMobile={isMobile} />
    </Grid>
  );
}
